import clsx from 'clsx';
import React from 'react';
import {
  getCardBrandIcon,
  normalizeCardBrand,
} from 'src/components/Selectors/BuyerSelector/BuyerCard';
import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

import * as styles from './PaymentMethodCard.css';

type PaymentMethodCardProps = {
  cardBrand?: string | null;
  cardSummary?: string | null;
  expiryMonth?: number | null;
  expiryYear?: number | null;
  isDefault?: boolean;
  rightComponent?: React.ReactNode;
  flattened?: boolean;
};

export const PaymentMethodCard = ({
  cardBrand,
  cardSummary,
  expiryMonth,
  expiryYear,
  isDefault,
  rightComponent,
  flattened = false,
}: PaymentMethodCardProps) => {
  const hasCleanPaymentDisplay = useUserHasFeature(Feature.CleanPaymentDisplay);
  return (
    <Stack
      alignItems="center"
      justifyContent="spaceBetween"
      className={clsx(styles.cardInfo, flattened && styles.noBorder)}
      width="full"
    >
      <Stack
        direction={flattened ? 'row' : 'column'}
        gap={flattened ? 'm' : undefined}
        alignItems={flattened ? 'center' : undefined}
      >
        <span className={styles.cardNumber}>
          {getCardBrandIcon(cardBrand)}{' '}
          {hasCleanPaymentDisplay
            ? [normalizeCardBrand(cardBrand), cardSummary]
                .filter(Boolean)
                .join(' ')
            : `**** ${cardSummary}`}
        </span>
        {expiryMonth != null && expiryYear != null && (
          <span className={styles.cardExpiry}>
            <Content id={ContentId.Expires} /> {expiryMonth}/{expiryYear}
          </span>
        )}
      </Stack>
      <Stack alignItems="center" gap="m">
        {isDefault && (
          <span className={styles.cardBadge}>
            <Content id={ContentId.Default} />
          </span>
        )}
        {rightComponent}
      </Stack>
    </Stack>
  );
};
